import { useState, useRef } from 'react';
import { Search } from 'lucide-react';
import { useLocation } from 'wouter';
import { Input } from '@/components/ui/input';

export function SearchBar() {
  const [query, setQuery] = useState('');
  const [, setLocation] = useLocation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = () => {
    if (query.trim().length >= 2) {
      setLocation(`/cerca?q=${encodeURIComponent(query.trim())}`);
      setQuery('');
      inputRef.current?.blur();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="relative w-full max-w-md">
      <div className="relative flex items-center">
        <Input
          ref={inputRef}
          type="text"
          placeholder="Cerca..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full pl-3 pr-9 h-9 text-sm bg-white text-foreground border border-border rounded-md focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all placeholder:text-muted-foreground"
          data-testid="input-search"
        />
        <button
          type="button"
          onClick={handleSearch}
          className="absolute right-0 h-9 w-9 flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
          data-testid="button-search"
          aria-label="Cerca"
        >
          <Search className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
